export function replaceDocumentLocation(target: string): void {
  window.location.replace(target);
}
